export const facultyOptions: {
  "Faculty of Quran": string[];
  "Faculty of Alimiyat": string[];
  "Faculty of Deeniyat": string[];
  "Faculty of Fazilat": string[];
  "Faculty of Languages(Arabic)": string[];
  "Faculty of Languages(English)": string[];
  "Faculty of Languages(Urdu)": string[];
  "Short Courses": string[];
  "Darul-Ifta": string[];
} = {
  "Faculty of Quran": [
    "Noorani Qaedah Course",
    "Quran Recitation Course",
    "Tajweed Course",
    "Quran Memorization Course",
    "Seven Qiraats Course",
    "Quran Ijazah Program",
    "Quran's Translation Course",
    "Tafseer Course",
  ],
  "Faculty of Deeniyat": [
    "Deeniyat for Kids",
    "Deeniyat for Men",
    "Deeniyat for Women",
  ],
  "Faculty of Alimiyat": [
    "Alimiyat with Darse Nizami Curriculum",
    "Alimiyat with Modern Curriculum",
  ],
  "Faculty of Fazilat": [
    "Fazilat in Quranic Science",
    "Fazilat in Hadith Science",
    "Fazilat in Islamic Jurisprudence",
    "Fazilat in Theology",
    "Fazilat in Islamic Finance",
    "Fazilat in Arabic Language",
  ],
  "Faculty of Languages(Arabic)": [
    "Foundation Arabic Course",
    "Arabic Speaking Course",
    "Quranic Arabic Course",
    "Classical Arabic Course",
    "Nah & Sarf Course",
    "Balaghat Course",
    "Arooz & Quafiyah Course",
  ],
  "Faculty of Languages(English)": [
    "Elementary English Course",
    "Intermediate English Course",
    "Advanced English Course",
  ],
  "Faculty of Languages(Urdu)": [
    "Elementary Urdu Course",
    "Intermediate Urdu Course",
    "Advanced Urdu Course",
  ],
  "Short Courses": [
    "Ibadaat Course",
    "Zakat Course",
    "Ramadan Special Course",
    "Hajj && Umrah Course",
    "Life of Prophet(Seerat) Course",
    "inheritance(Meerath) Course",
    "Imamat Course",
  ],
  "Darul-Ifta": ["Ifta Course"],
};

export const timingOptions = [
  "01:00 to 02:00",
  "02:00 to 03:00",
  "03:00 to 04:00",
  "04:00 to 05:00",
  "05:00 to 06:00",
  "06:00 to 07:00",
  "07:00 to 08:00",
  "08:00 to 09:00",
  "09:00 to 10:00",
  "10:00 to 11:00",
  "11:00 to 12:00",
  "12:00 to 13:00",
  "13:00 to 14:00",
  "14:00 to 15:00",
  "15:00 to 16:00",
  "16:00 to 17:00",
  "17:00 to 18:00",
  "18:00 to 19:00",
  "19:00 to 20:00",
  "20:00 to 21:00",
  "21:00 to 22:00",
  "22:00 to 23:00",
  "23:00 to 00:00",
  "00:00 to 01:00",
];

export const languageOptions = ["Arabic", "Urdu", "English"];

export const genderOptions = ["Male", "Female", "Other"];
